// extracted by mini-css-extract-plugin
export default {"gdprWrapper":"styles_gdprWrapper__egjW6","spin":"styles_spin__yzI6Y"};